import { defineMessages } from "react-intl";
const messages = defineMessages({
    title: { id: "app.aiDiscoverability.trackedCompetitors.title", defaultMessage: "Tracked Competitors" },
    infoTooltip: {
        id: "app.aiDiscoverability.trackedCompetitors.infoTooltip",
        defaultMessage: "Communities selected to rank against directly.",
    },
    editCompSet: { id: "app.aiDiscoverability.trackedCompetitors.editCompSet", defaultMessage: "Edit Comp Set" },
    emptyHeading: {
        id: "app.aiDiscoverability.trackedCompetitors.emptyHeading",
        defaultMessage: "No competitors added yet",
    },
    emptySubtext: {
        id: "app.aiDiscoverability.trackedCompetitors.emptySubtext",
        defaultMessage: "Add communities to see how you rank against the competitors that matter most to you",
    },
    addCompetitors: {
        id: "app.aiDiscoverability.trackedCompetitors.addCompetitors",
        defaultMessage: "+ Add Competitors",
    },
    pendingHeading: {
        id: "app.aiDiscoverability.trackedCompetitors.pendingHeading",
        defaultMessage: "Results pending first report",
    },
    pendingSubtextEmpty: {
        id: "app.aiDiscoverability.trackedCompetitors.pendingSubtextEmpty",
        defaultMessage: "Add competitors now — they'll be scored once your first report completes.",
    },
    pendingSubtextConfigured: {
        id: "app.aiDiscoverability.trackedCompetitors.pendingSubtextConfigured",
        defaultMessage: "Your competitors are saved and will be scored once your first report completes.",
    },
    targetCallout: { id: "app.aiDiscoverability.trackedCompetitors.targetCallout", defaultMessage: "You - #{rank}" },
    dotTooltipScore: {
        id: "app.aiDiscoverability.trackedCompetitors.dotTooltipScore",
        defaultMessage: "Score: {score}",
    },
    bestPerforming: {
        id: "app.aiDiscoverability.trackedCompetitors.bestPerforming",
        defaultMessage: "Best performing: {features}",
    },
    mostCitedBy: { id: "app.aiDiscoverability.trackedCompetitors.mostCitedBy", defaultMessage: "Most cited by:" },
    noneLabel: { id: "app.aiDiscoverability.trackedCompetitors.noneLabel", defaultMessage: "None" },
    rankNotAvailable: { id: "app.aiDiscoverability.trackedCompetitors.rankNotAvailable", defaultMessage: "N/A" },
    scoreNotAvailable: { id: "app.aiDiscoverability.trackedCompetitors.scoreNotAvailable", defaultMessage: "N/A" },
    invisibleLabel: { id: "app.aiDiscoverability.trackedCompetitors.invisibleLabel", defaultMessage: "Invisible" },
});
export default messages;
